module.exports = __webpack_public_path__ + "static/media/firebase.a1c1449a.svg";